import React, { useState } from 'react';
import { Modal, Input, Button, message, Result, Typography } from 'antd';
import { KeyOutlined } from '@ant-design/icons';
import { activationAPI } from '../services/api';

const { Text } = Typography;

interface Props {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const ActivationModal: React.FC<Props> = ({ open, onClose, onSuccess }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);

  const handleActivate = async () => {
    const trimmed = code.trim();
    if (!trimmed) { message.warning('请输入激活码'); return; }
    setLoading(true);
    try {
      const res = await activationAPI.activate(trimmed);
      setResult(res);
      onSuccess?.();
    } catch (err: any) {
      message.error(err?.response?.data?.detail || '激活失败');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCode('');
    setResult(null);
    onClose();
  };

  return (
    <Modal
      title={<><KeyOutlined /> 激活码兑换</>}
      open={open}
      onCancel={handleClose}
      footer={result ? (
        <Button type="primary" onClick={handleClose}>确定</Button>
      ) : (
        <Button type="primary" loading={loading} onClick={handleActivate}>激活</Button>
      )}
      destroyOnClose
    >
      {result ? (
        <Result
          status="success"
          title="激活成功"
          subTitle={`已激活 ${result.plan_display_name || result.plan_name} 套餐，有效期 ${result.duration_days} 天`}
          extra={<Text type="secondary">到期时间: {result.period_end?.slice(0, 10)}</Text>}
        />
      ) : (
        <>
          <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
            请输入激活码以激活或续期套餐
          </Text>
          <Input
            size="large"
            placeholder="PD-XXXX-XXXX-XXXX"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            onPressEnter={handleActivate}
            maxLength={20}
            style={{ fontFamily: 'monospace', letterSpacing: 1 }}
          />
        </>
      )}
    </Modal>
  );
};

export default ActivationModal;
